import Login from './Login'
import Register from './Register'

export default { Login, Register }
